import { Box, Typography } from "@mui/material";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import Button from "../../../../components/Button";
import { useLanguage } from "../../../../context/LanguageContext";
import { Colors } from "../../../../styles/theme";
import platformStyles from "../Platform/Platform.styles";
import styles from "./GetStarted.styles";

const GetStarted = () => {
  const { translate, selectedLanguage } = useLanguage();
  const isRTL = selectedLanguage === "ar";
  const steps = [
    {
      number: "01",
      title: translate("get started create account"),
      description: translate("get started create account description"),
    },
    {
      number: "02",
      title: translate("get started download app"),
      description: translate("get started download app description"),
    },
  ];

  return (
    <Box
      component="section"
      id="get-started"
      sx={{
        ...platformStyles.Platform_container,
        backgroundColor: "#EEF3FA",
        direction: isRTL ? "rtl" : "ltr",
      }}
    >
      <Box sx={platformStyles.Platform_textContainer}>
        <Typography
          variant="subtitle2"
          component="p"
          color={Colors.primary}
          mb={{ xs: 1.25, sm: 2 }}
          sx={{
            fontWeight: 800,
            letterSpacing: 3,
            textAlign: "center",
            textTransform: "uppercase",
          }}
        >
          {translate("get started eyebrow")}
        </Typography>
        <Typography
          variant="h2"
          sx={{
            color: Colors.navy,
            fontSize: { xs: "2.35rem", md: "4rem" },
            fontWeight: 800,
            letterSpacing: 0,
            lineHeight: 1.08,
            textAlign: "center",
          }}
        >
          {translate("get started header")}
        </Typography>
        <Typography
          variant="h6"
          component="p"
          color={Colors.text}
          mt={{ xs: 1.5, sm: 2 }}
          sx={{
            fontWeight: 500,
            lineHeight: 1.65,
            textAlign: "center",
          }}
        >
          {translate("get started description")}
        </Typography>
      </Box>
      <Box sx={styles.GetStarted_grid}>
        {steps.map((step) => (
          <Box key={step.number} sx={platformStyles.Platform_card}>
            <Box sx={platformStyles.Platform_iconContainer}>
              <Typography sx={styles.GetStarted_number}>
                {step.number}
              </Typography>
            </Box>
            <Typography variant="h5" component="h3" sx={platformStyles.Platform_cardTitle}>
              {step.title}
            </Typography>
            <Typography
              variant="body1"
              sx={platformStyles.Platform_cardDescription}
            >
              {step.description}
            </Typography>
          </Box>
        ))}
      </Box>
      <Box sx={styles.GetStarted_action}>
        <Button
          text={translate("download sharp view")}
          styling="primary"
          to="/downloads"
          endIcon={<NorthEastIcon />}
          sx={styles.GetStarted_downloadButton}
        />
      </Box>
    </Box>
  );
};

export default GetStarted;
